export enum TimeOptionType {
    none = -1,
    start = 0,
    end = 1,
}